import { createSlice } from '@reduxjs/toolkit';
const initialState = { users: {} };

export const sliceUsers = createSlice({
  name: 'Users',
  initialState,
  reducers: {
    setUser(state, { payload: userData }) {
      state.users[userData._id] = userData;
    },
    setUsers(state, { payload: userData }) {
      userData.forEach(element => {
        state.users[element._id] = element;
      });
    },
  },
});

export const { setUser, setUsers } = sliceUsers.actions;
export default sliceUsers.reducer;
